import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProducts = async (params = {}) => {
  const { data } = await api.get("/products", { params });
  return data;
};

export const fetchProduct = async (slug) => {
  const { data } = await api.get(`/products/${slug}`);
  return data;
};

export const createOrder = async (payload) => {
  const { data } = await api.post("/orders", payload);
  return data;
};

export const trackVisit = async () => {
  try {
    await api.post("/track/visit", { path: window.location.pathname, referrer: document.referrer || "" });
  } catch (e) { /* silent */ }
};

export const getStats = async (token) =>
  (await api.get("/admin/stats", { headers: { Authorization: `Bearer ${token}` } })).data;

export const fmtPrice = (n) =>
  new Intl.NumberFormat("ro-RO", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(n) + " lei";

// ---- Admin ----
const authCfg = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const adminLogin = async (email, password) => (await api.post("/auth/login", { email, password })).data;
export const adminMe = async (token) => (await api.get("/auth/me", authCfg(token))).data;
export const createProduct = async (token, payload) => (await api.post("/products", payload, authCfg(token))).data;
export const updateProduct = async (token, id, payload) => (await api.put(`/products/${id}`, payload, authCfg(token))).data;
export const deleteProduct = async (token, id) => (await api.delete(`/products/${id}`, authCfg(token))).data;
export const listOrders = async (token) => (await api.get("/orders", authCfg(token))).data;

export const generateAwb = async (token, orderNumber, payload) =>
  (await api.post(`/orders/${orderNumber}/awb`, payload, authCfg(token))).data;

export const getAwbLabel = async (token, orderNumber) => {
  const res = await api.get(`/orders/${orderNumber}/awb/label`, { ...authCfg(token), responseType: "blob" });
  return res.data;
};

export const generateInvoice = async (token, orderNumber) =>
  (await api.post(`/orders/${orderNumber}/invoice`, {}, authCfg(token))).data;

export const updateOrderStatus = async (token, orderNumber, status) =>
  (await api.patch(`/orders/${orderNumber}/status`, { status }, authCfg(token))).data;

export const uploadImage = async (token, file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
  return { ...data, absoluteUrl: `${BACKEND_URL}${data.url}` };
};
